import React, { FC, ReactElement } from 'react';
import { WizardPage } from '@buyside/components/presentation/Form/Wizard/Wizard';
import { ApplicantTypes } from '@interfaces/userApplication/userApplication';
import { WizardContextProps } from '@interfaces/wizard/wizard';
import { ApplicantTypePage } from './ApplicantTypePage';
import { applicantTypePageSchema } from '@buyside/components/presentation/UserApplication/Helpers/validations';

const ApplicantTypeContainer: FC<{
  handleApplicantType: (applicantType: ApplicantTypes) => void;
  isLoading: boolean;
  isRobot: boolean;
  validationSchema: typeof applicantTypePageSchema;
}> = ({ validationSchema, handleApplicantType, isLoading, isRobot }): ReactElement => {
  return (
    <WizardPage validationSchema={validationSchema}>
      {({ setFieldValue, touched, errors, values }: WizardContextProps): ReactElement => {
        const handleSelect = (applicantType: ApplicantTypes): void => {
          setFieldValue('applicantType', applicantType);
          handleApplicantType(applicantType);
        };
        return (
          <ApplicantTypePage
            handleSelect={handleSelect}
            touched={touched}
            errors={errors}
            isLoading={isLoading}
            isRobot={isRobot}
            values={values}
          />
        );
      }}
    </WizardPage>
  );
};

export default ApplicantTypeContainer;
